<template>
  <div class="row mb-40">
    <div class="col-xxl-10 col-lg-8 pe-xxl-8">
      <div class="transfer-form-panel">
        <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-25 position-relative">
            <label class="d-block fs-14 text-black mb-2">{{ $t("transfer_page.order_tax") }} (%)</label>
              <input
                :value="form.order_tax"
                @input="$emit('update:formKey', 'order_tax', parseFloat(($event.target as HTMLInputElement).value) || 0)"
                type="number"
                class="transfer-form-field w-100 d-block shadow-none fs-14 rounded-1 text-title h-55 ps-3 pe-5"
                placeholder="0"
              />
              <span
                class="percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center transfer-input-addon"
                style="right: 15px; top: 38px;"
              >
                %
              </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-25 position-relative">
            <label class="d-block fs-14 text-black mb-2">{{ $t("transfer_page.discount") }} ($)</label>
              <input
                :value="form.discount"
                @input="$emit('update:formKey', 'discount', parseFloat(($event.target as HTMLInputElement).value) || 0)"
                type="number"
                class="transfer-form-field w-100 d-block shadow-none fs-14 rounded-1 text-title h-55 ps-3 pe-5"
                placeholder="0"
              />
              <span
                class="percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center fw-semibold fs-16 transfer-input-addon"
                style="right: 15px; top: 38px;"
              >
                $
              </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-25 position-relative">
            <label class="d-block fs-14 text-black mb-2">{{ $t("transfer_page.shipping_cost") }} ($)</label>
              <input
                :value="form.shipping"
                @input="$emit('update:formKey', 'shipping', parseFloat(($event.target as HTMLInputElement).value) || 0)"
                type="number"
                class="transfer-form-field w-100 d-block shadow-none fs-14 rounded-1 text-title h-55 ps-3 pe-5"
                placeholder="0"
              />
              <span
                class="percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center fw-semibold fs-16 transfer-input-addon"
                style="right: 15px; top: 38px;"
              >$</span
              >
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-25">
            <label class="d-block fs-14 text-black mb-2">{{ $t("transfer_page.status") }}</label>
            <select
              :value="form.status"
              @change="$emit('update:formKey', 'status', ($event.target as HTMLSelectElement).value)"
              class="transfer-form-field rounded-1 fs-14 text-optional w-100 h-55 ps-3"
            >
              <option value="completed">{{ $t("transfer_page.status_completed") }}</option>
              <option value="pending">{{ $t("transfer_page.status_pending") }}</option>
              <option value="sent">{{ $t("transfer_page.status_sent") }}</option>
            </select>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="col-xxl-2 col-lg-4">
      <div class="card border-0 rounded-1 w-xxl-5 pt-12 pb-12 mb-md-25 shadow-sm transfer-summary-card">
        <table class="table style-two">
          <tbody>
            <tr>
              <th scope="row" class="fs-14 text-title lh-1 ls-1 fw-normal">
                {{ $t("transfer_page.order_tax") }} :
              </th>
              <td class="fs-14 fw-semibold lh-1 text-optional text-end">
                {{ Number(form.order_tax || 0).toFixed(0) }} %
              </td>
            </tr>
            <tr>
              <th scope="row" class="fs-14 text-title lh-1 ls-1 fw-normal">
                {{ $t("transfer_page.discount") }} :
              </th>
              <td class="fs-14 fw-semibold lh-1 text-optional text-end">
                $ {{ Number(form.discount || 0).toFixed(2) }}
              </td>
            </tr>
            <tr>
              <th scope="row" class="fs-14 text-title lh-1 ls-1 fw-normal">
                {{ $t("transfer_page.shipping") }} :
              </th>
              <td class="fs-14 fw-semibold lh-1 text-optional text-end">
                $ {{ Number(form.shipping || 0).toFixed(2) }}
              </td>
            </tr>
            <tr>
              <th scope="row" class="fs-14 text-title lh-1 ls-1 fw-normal">
                {{ $t("transfer_page.items") }} :
              </th>
              <td class="fs-14 fw-semibold lh-1 text-optional text-end">
                {{ totalQty }}
              </td>
            </tr>
            <tr>
              <th scope="row" class="fs-14 text-title lh-1 ls-1 fw-semibold">
                {{ $t("transfer_page.grand_total") }} :
              </th>
              <td class="fs-14 fw-bold lh-1 text-purple text-end">$ {{ Number(grandTotal || 0).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group mb-25">
        <label class="d-block fs-14 text-black mb-2">{{ $t("transfer_page.notes") }}</label>
        <textarea
          :value="form.note"
          @input="$emit('update:formKey', 'note', ($event.target as HTMLTextAreaElement).value)"
          cols="30"
          rows="5"
          :placeholder="$t('transfer_page.add_note')"
          class="transfer-form-field d-block w-100 rounded-1 resize-none fs-14 text-title p-3"
        ></textarea>
      </div>
    </div>
    <div class="col-xl-4">
      <button
        class="btn style-one d-inline-block transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 mb-20"
        type="button"
        @click="$emit('submit')"
      >
        {{ $t("transfer_page.submit_transfer") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CreateTransferFrom",
  props: {
    form: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    totalQty: {
      type: Number,
      default: 0,
    },
    subTotal: {
      type: Number,
      default: 0,
    },
    grandTotal: {
      type: Number,
      default: 0,
    },
  },
  emits: ["submit", "update:formKey"],
});
</script>

<style scoped>
.transfer-form-panel {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  margin-bottom: 4px;
}

.transfer-input-addon {
  min-width: 54px;
}

.transfer-form-field {
  background: #fff;
  border: 1px solid #e6ebf2;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.transfer-form-field:focus {
  outline: none;
  border-color: #5d5fef;
  box-shadow: 0 0 0 3px rgba(93, 95, 239, 0.12);
}

.transfer-summary-card {
  background: #fff;
}
</style>
